/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const BidderEvaluation = {

	delete (context, evaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/bidder-evaluation"
			+ "?evaluationId=" + evaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, evaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder-evaluation"
			+ "?evaluationId=" + evaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, search, page, result, sort, onSuccess, onError, options) {
		Api.get(context,
			"/bidder-evaluation/list"
			+ "?search=" + search
			+ "&page=" + page
			+ "&result=" + result
			+ "&sort=" + sort
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPersonalEvaluations (context, bidderId, recentEvaluations, onSuccess, onError, options) {
		Api.get(context,
			"/bidder-evaluation/personal-evaluations"
			+ "?bidderId=" + bidderId
			+ "&recentEvaluations=" + recentEvaluations
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProject (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder-evaluation/project"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/bidder-evaluation"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExport (context, search, sort, onSuccess, onError, options) {
		Api.post(context,
			"/bidder-evaluation/export"
			+ "?search=" + search
			+ "&sort=" + sort
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportPersonalEvaluations (context, bidderId, recentEvaluations, onSuccess, onError, options) {
		Api.post(context,
			"/bidder-evaluation/export-personal-evaluations"
			+ "?bidderId=" + bidderId
			+ "&recentEvaluations=" + recentEvaluations
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, evaluationId, bidderEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/bidder-evaluation"
			+ "?evaluationId=" + evaluationId
			, bidderEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, evaluationId, bidderEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/bidder-evaluation/finish"
			+ "?evaluationId=" + evaluationId
			, bidderEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
